import React, {useContext} from 'react'
import ReservedForOptions from '../../ReservationReserve/CustomComponents/ReservedForOptions'
import {Button, Typography, IconButton, Tooltip} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import './ReservedForGantt.scss'
import {ReservationContext} from '../../../context/Reservation'
export default function ReservedForGantt({handleClose, handleContinue}) {
  const {reservation} = useContext(ReservationContext)
  return (
    <>
      <div className="reserved-for-box ap-big-bubble">
        <Typography className="ap-typography ap-typography--lg reserved-for-text">
          Reserve For
        </Typography>
        <IconButton className="ap-icon-button ap-modal__btn-x" onClick={handleClose}>
          <CloseIcon style={{color: '#1d2331'}} />
        </IconButton>
        <div className="reserved-for-popup">
          <ReservedForOptions gantt={true} />
        </div>

        <Button
          onClick={handleContinue}
          className="ap-button ap-button--primary reserved-for-continue"
          disabled={reservation.reserved_for.name ? false : true}
        >
          Continue
        </Button>
      </div>
    </>
  )
}
